module.exports = __webpack_public_path__ + "img/icon-web-home-04.f657cfad.jpg";